import {
  Component,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';

import { BaseSegmentComponent } from '../base/_base-segment.component';


@Component({
  template: '',
})
export class BasePackagingComponent extends BaseSegmentComponent {

  filterData(data: any, names: string[]): any {
    return this.getDataByNames(data, names, false);
  }

  getDataByNames(data: any, names: Array<string>, group: boolean): any {
    const func: any = group ? _.groupBy : _.filter;
    return func(data, (item: any) => {
     return _.some(names, (property: string) => {
        return this.matchItemName(item.item_name, '.' + property);
      });
    });
  }

  hasField(value: string, data: Array<string>): boolean {
    return _.some(data, (field: string) => {
      return this.matchItemName(value, field);
    });
  }

  matchItemName(itemName: any, value: string): boolean {
    return itemName.indexOf(value) !== -1;
  }

  separateData(data: any, names: string[]): any {
    return this.getDataByNames(data, names, true);
  }


}
